<template>
    <div>
        <simple-tab :tab-list="tabList" :active.sync="active"></simple-tab>
        <div class="content-all">
            <div class="head">{{headList[active]}}
                <span class="description">说明</span>
                <span class="sub" :class="{ 'sub-disable': !active && !isSelf }">操作</span>
            </div>
            <div class="form" v-if="!active">
                <div class="row">
                    <label class="title">头像</label>
                    <div class="content">
                        <avatar @image-ok="changeLogo" ref="avatar" :url="appInfo.logo" :size="48" :changable="true" :aspectRatio="0"></avatar>
                    </div>
                    <span class="btn" @click="changeImg" v-if="isSelf">更换</span>
                </div>
                <div class="row">
                    <label class="title">小程序名称</label>
                    <div class="content">
                        <span v-if="!editType" class="info">{{appInfo.name}}</span>
                        <div class="edit-content" v-else>
                            <input type="text" placeholder="输入小程序名，推荐4-12个字" class="input" ref="input" @blur="changeName" :maxlength="24" v-model="nameBackup">
                            <span class="action">
                                <i class="act-icon clear" @mousedown="clear"></i>
                            </span>
                        </div>
                        <p class="error-info" v-if="editType">{{errorInfo}}</p>
                    </div>
                    <span class="btn" @click="editName" v-if="isSelf">编辑</span>
                </div>
                <div class="row">
                    <label class="title">介绍</label>
                    <div class="content">
                        <span v-show="!editIntroType" class="info textarea-info">{{appInfo.introduction || '暂无介绍'}}</span>
                        <div class="edit-textarea" v-show="showIntroInput">
                            <textarea type="text" placeholder="暂无介绍" class="input bigInput" ref="intro" @blur="changeIntro" :maxlength="120" v-model="introBackup"></textarea>
                        </div>
                        <p class="error-info" v-if="editIntroType">{{errorInfo}}</p>
                    </div>
                    <span class="btn" @click="editIntro" v-if="isSelf">编辑</span>
                </div>
                <div class="row">
                    <label class="title">主体</label>
                    <div class="content">
                        <span class="info">{{appInfo.companyName}}</span>
                    </div>
                </div>
                <div class="row row-lines3">
                    <label class="title">动态分享专用设置</label>
                    <div class="content">
                        <img v-if="appInfo.dynamic && appInfo.dynamic.shareImage" style="margin-top: 20px;" :src="appInfo.dynamic.shareImage" width="160" height="90" />
                        <div class="no-share-image" v-else>暂未设置</div>
                    </div>
                    <div class="desc share-info" v-if="appInfo.dynamic && appInfo.dynamic.shareContent">{{appInfo.dynamic.shareContent}}</div>
                    <div class="btn">
                        <div v-if="isSelf" @click="setShareSetting">编辑</div>
                    </div>
                </div>
                <div class="row">
                    <label class="title">渠道支持</label>
                    <div class="content">
                        <span class="info">{{channelInfo}}</span>
                    </div>
                </div>
                <div class="row">
                    <label class="title">创建时间</label>
                    <div class="content">
                        <span class="info">{{timeFormat(appInfo.ctime)}}</span>
                    </div>
                </div>
                <div class="row">
                    <label class="title">类目配置</label>
                    <div class="content">
                        <span class="info type">
                            <span class="type-item" v-for="(item, index) in typeList" :key="index">
                                {{item}}
                            </span>
                        </span>
                    </div>
                </div>
                <div class="row">
                    <label class="title">暂停服务</label>
                    <div class="content">
                        <span class="info service-status">{{serviceInfo}}</span>
                        <span class="service-description">{{'暂停服务后，用户将不可正常访问线上版本小程序'}}</span>
                    </div>
                    <span class="btn" @click="showServiceDialog" v-if="!isMultipleChannel && isSelf && serviceStatus === 0">暂停服务</span>
                    <span class="btn" @click="openConfirm('resumService')" v-if="!isMultipleChannel && isSelf && serviceStatus === 1">恢复服务</span>
                    <span class="btn" @click="showServiceDialog" v-if="isMultipleChannel && isSelf">编辑</span>
                </div>
                <div class="row row-lines2">
                    <label class="title">基础库最低版本设置</label>
                    <div class="content base-content">
                        <span class="info">
                            <!-- {{appInfo.minVersion}} -->
                            <div class="piece" v-for="(item, key) in minVersionList" :key="key">
                                {{`${item.channelName}[${item.minVersion}]`}}
                            </div>
                        </span>
                    </div>
                    <div class="desc">若用户使用的基础库版本低于设置的最低版本要求，则无法正常使用小程序，并提示更新App。<span @click="openDetail" class="detail-btn">查看版本更新记录</span></div>
                    <div class="btn">
                        <div v-if="isSelf" @click="setVersion">设置</div>
                    </div>
                </div>
                <div class="disable-tips" v-if="!isSelf">不支持编辑。服务权限已授权给第三方开发者，可在第三方开发者提供的平台上完成操作。</div>
            </div>
            <div class="form" v-if="active == 1">
                <div class="row dev">
                    <label class="title long">AppID(小程序ID)</label>
                    <div class="content">
                        <span class="info">{{appInfo.appId}}</span>
                    </div>
                    <span class="btn" @click="copy(appInfo.appId)">复制</span>
                </div>
                <div class="row last">
                    <label class="title long">AppSecret(小程序密钥)</label>
                    <div class="content">
                        <span class="info">{{appInfo.appSecret}}</span>
                    </div>
                    <span class="btn" @click="copy(appInfo.appSecret)">复制</span>
                </div>
            </div>
            <textarea class="textarea" rows="1" cols="1" ref="text"></textarea>
            <el-dialog :visible.sync="versionVisible" width="700px" custom-class="version-dialog" :before-close="close" top="204px">
                <div slot="title" class="title-dialog">设置最低基础库版本</div>
                <div class="content">
                    <div class="tips">设置小程序支持的最低版本，若用户APP版本号低于设置的最低版本号，系统自动提示用户需更新APP版本。  <a class="btn-text" @click="showExample">查看示例</a></div>
                    <div class="tips">
                        选择渠道
                        <el-select v-model="versionChannel" @change="versionChannelChange" value-key="channelKey" size="mini" style="display: inline-block;width: 279px;">
                            <el-option v-for="channel in channelList" :key="channel.channelKey" :label="channel.channelName" :value="channel.channelKey"></el-option>
                        </el-select>
                    </div>
                    <el-table
                        v-loadMore="loadMore"
                        :data="versionList"
                        highlight-current-row
                        @current-change="handleCurrentChange"
                        header-cell-class-name="table-header-cell"
                        cell-class-name="table-cell"
                        row-class-name="table-row"
                        class="table-version"
                        height="332"
                    >
                        <el-table-column label="版本" prop="baseVersion" align="center"></el-table-column>
                        <el-table-column label="版本更新内容" prop="newContentList" align="center" width="300">
                            <template slot-scope="scope"><a class="btn-text" @click="showAll(scope.row)">查看详情</a></template>
                        </el-table-column>
                        <el-table-column label="选择" align="center">
                            <template slot-scope="scope">
                                <div class="circle" :class="{'active': version === scope.row.baseVersion}"></div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div slot="footer" class="footer">
                        <btn :type="1" info="取消" @click="close"></btn>
                        <btn :type="0" v-if="showConfirmBtn" info="确定" @click="versionComfirm"></btn>
                    </div>
                </div>
            </el-dialog>
            <el-dialog :visible.sync="exampleVisible" width="300px" top="156px" custom-class="example-dialog" :close-on-click-modal="false">
                <div class="example-img">
                    <div class="appInfo">
                        <img :src="appInfo.logo || defaultFace" width="48px" height="48px"/>
                        <div>{{appInfo.name}}</div>
                    </div>
                </div>
            </el-dialog>
            <el-dialog :visible.sync="versionContentVisible " width="500px" custom-class="example-dialog" :close-on-click-modal="false">
                <div class="title-dialog" slot="title">{{versionInfo.num}} 版本更新内容</div>
                <div class="version-container">
                    <!-- <div class="version-content" style="white-space: pre-line;
                    line-height: 20px;">{{versionInfo.content}}</div> -->
                    <div class="version-content">
                        <ol>
                            <li v-for="item in versionInfo.content" style="text-align: left;">{{item}}</li>
                        </ol>
                    </div>
                </div>
            </el-dialog>
        </div>
        <div class="content-all" v-if="active == 1">
            <div class="domain-type">
                <span class="domain-name">服务器域名</span>
                <span class="edit-btn" :class="{'edit-disabled': !serverLimit}" v-if="isSelf">
                    <i class="edit-icon" :class="{'edit-icon-disabled': !serverLimit}"></i>
                    <span class="text" :class="{'text-disabled': !serverLimit}" @click="showServerDomain">编辑</span>
                </span>
            </div>
            <div class="head">域名
                <span class="description">说明</span>
                <span class="operator" v-if="!isSelf">编辑</span>
            </div>
            <developer-setting :info="domainInfo" :limit="serverLimit" :totalServer="totalServer"></developer-setting>
            <div class="disable-tips" v-if="!isSelf">不支持编辑。服务权限已授权给第三方开发者，可在第三方开发者提供的平台上完成操作。</div>
        </div>
        <div class="content-all" v-if="active == 1 && !isSmallGame">
            <div class="domain-type">
                <span class="domain-name">业务域名</span>
                <span class="edit-btn ep" :class="{'edit-disabled': !busiLimit}">
                    <i class="edit-icon" :class="{'edit-icon-disabled': !busiLimit}"></i>
                    <span class="text" :class="{'text-disabled': !busiLimit}" @click="showBusinessDomain">编辑</span>
                </span>
            </div>
            <div class="head">域名
                <span class="description">说明</span>
            </div>
            <div class="form">
                <div class="row domain">
                    <span class="left">
                        <p v-for="(item, index) in domainInfo.businessList || []" :key="index">{{item.domain}}</p></span>
                    <span class="right">最多可以添加20个业务域名<br/>一年内可修改50次业务域名<br/>今年还可修改{{busiLimit}}次</span>
                </div>
            </div>
        </div>
        <server-config
            v-if="serverDomainDialogVisible"
            :visible.sync="serverDomainDialogVisible"
            v-model="serverInfo"
            @refresh="modifyRefresh(1)"
            ></server-config>
        <business-domain-setting
            v-if="businessDomainDialogVisible"
            :visible.sync="businessDomainDialogVisible"
            :info="businessInfo"
            @cancel="cancel"
            @refresh="modifyRefresh(0)"
            ></business-domain-setting>
        <suspend-service
            class="suspend-service"
            v-if="suspendServiceDialogVisible"
            :serviceVisible.sync="suspendServiceDialogVisible"
            :appInfo="appInfo"
            :isMultipleChannel="isMultipleChannel"
            :suspendInfoList="suspendInfoList"
            @openConfirm="openConfirm"
            @showPreview="showPreview"
            @close="closeServiceDialog"
            ></suspend-service>
        <preview
            class="preview"
            v-if="previewVisible"
            :previewVisible.sync="previewVisible"
            @closePreview="closePreview"
            ></preview>
        <confirm class="confirm-dialog" :visible.sync="ConfirmVisible">
            <div class="icon-success" slot="icon" v-if="success"></div>
            <h4 class="title-dia" slot="title">{{dialogInfo[type].title}}</h4>
            <p class="tips">{{dialogInfo[type].content}}</p>
            <span slot="op-btns" class="op-btns">
                <btn v-for="(item, index) in dialogInfo[type].btns" :key="index" :type="item.type" :info="item.label" @click="item.clickEvent"></btn>
            </span>
        </confirm>
        <GameSharingDynamics
            v-if="shareSettingDialog"
            :shareVisible.sync="shareSettingDialog"
            :info="appInfo"
            @closeShareSeeting="closeShareSeeting"
        >
        </GameSharingDynamics>
    </div>
</template>
<script>
import SimpleTab from '@/components/SimpleTab.vue';
import Avatar from '@/components/Avatar.vue';
import DeveloperSetting from '@/components/developer/DeveloperSetting.vue';
import dao from '@/lib/dao.js';
import ServerConfig from '@/components/developer/ServerConfig.vue';
import BusinessDomainSetting from '@/components/developer/BusinessDomainSetting.vue';
import SuspendService from '@/components/basic/SuspendService.vue';
import Btn from '@/components/Button.vue';
import Preview from '@/components/basic/Preview.vue';
import Confirm from '@/components/Confirm.vue';
import defaultFace from '@/assets/default_avatar.png';
import GameSharingDynamics from '@/components/basic/GameSharingDynamics.vue';
let vm;
export default {
    components: {
        SimpleTab,
        Avatar,
        DeveloperSetting,
        ServerConfig,
        BusinessDomainSetting,
        SuspendService,
        Btn,
        Preview,
        Confirm,
        Btn,
        GameSharingDynamics
    },
    props: {
        appInfo: {
            type: Object,
            default() {
                return {
                    appId: ''
                }
            }
        }
    },
    computed: {
        isSmallGame() {
            return this.appInfo.type == 1;
        },
        isSelf() {
            return this.appInfo.origin == 0; // 0: 小程序平台，1: 小游戏平台
        },
        isMultipleChannel() {
            return this.channelList && this.channelList.length > 1
        },
        suspendServiceNum() {
            let num = 0
            for(let item of this.suspendInfoList){
                if(item.status === 1){
                    num++
                }
            }
            return num
        },
        serviceInfo() {
            if(!this.suspendInfoList.length ) return ''
            if(this.suspendInfoList && this.suspendInfoList.length > 1) {
                return this.suspendServiceNum === 0 ? '未暂停服务' : `有${this.suspendServiceNum}个发布渠道服务暂停`
            }
            return (this.suspendInfoList[0] || {}).status === 0 ? '未暂停服务' : '已暂停服务'
        },
        channelInfo() {
            return this.channelList.map(item => item.channelName).join('、')
        },
        showConfirmBtn() {
            return !(!this.version || (this.version === (this.minVersionList.find(item => item.channelKey === this.versionChannel) || {}).minVersion ))
        }
    },
    data() {
        const self = this;
        return {
            typeList: [],
            active: 0,
            tabList: ['基本设置', '开发设置'],
            headList: ['基本信息', '开发者ID'],
            editType: false,
            editIntroType: false,
            showIntroInput: false,
            nameBackup: '',
            nameReg: '^[\\u4e00-\\u9fa5_a-zA-Z0-9]{4,24}$',
            errorInfo: '',
            serverDomainDialogVisible: false,
            businessDomainDialogVisible: false,
            domainInfo: {},
            busiLimit: 0,
            serverLimit: 0,
            serverInfo: {},
            businessInfo: {},
            introBackup: '',
            suspendServiceDialogVisible: false,
            previewVisible: false,
            ConfirmVisible: false,
            dialogInfo: {
                'suspendService': {
                    title: '暂停小程序服务?',
                    content: '暂停服务后，用户将不可以正常使用小程序，但不影响代码版本的审核和发布，是否确认暂停服务',
                    btns: [
                        {
                            label: '取消',
                            type: 1,
                            clickEvent() {
                                self.closeConfirm();
                            }
                        },
                        {
                            label: '确定',
                            type: 0,
                            clickEvent() {
                                self.suspendService();
                            }
                        }
                    ]
                },
                'alreadySuspend': {
                    title: '已暂停小程序的服务',
                    content: `用户将不可以访问线上版本小程序。状态将在1分钟内生效。`,
                    btns: [
                        {
                            label: '确定',
                            type: 0,
                            clickEvent() {
                                self.closeConfirm();
                            }
                        }
                    ]
                },
                'resumService': {
                    title: '恢复小程序服务?',
                    content: '是否恢复小程序服务？恢复服务后，用户将可以正常访问线上版本小程序',
                    btns: [
                        {
                            label: '取消',
                            type: 1,
                            clickEvent() {
                                self.closeConfirm();
                            }
                        },
                        {
                            label: '恢复',
                            type: 0,
                            clickEvent() {
                                self.resumService();
                            }
                        }
                    ]
                },
                'alreadyResum': {
                    title: '小程序服务已恢复',
                    content: `用户将可以正常访问线上版本小程序，修改将在1分钟内生效。`,
                    btns: [
                        {
                            label: '确定',
                            type: 0,
                            clickEvent() {
                                self.closeConfirm();
                            }
                        }
                    ]
                },
                'versionSet': {
                    title: ``,
                    content: '',
                    btns: [
                        {
                            label: '取消',
                            type: 1,
                            clickEvent() {
                                self.closeConfirm();
                            }
                        },
                        {
                            label: '确定',
                            type: 0,
                            clickEvent() {
                                self.submit();
                            }
                        }
                    ]
                },
            },
            type: 'suspendService',
            success: false,
            suspendServiceInfo: {},
            versionVisible: false,
            versionList: [],
            version: '',
            versionChannel: '',
            exampleVisible: false,
            pageNum: 1,
            total: 0,
            serviceStatus: 0,
            defaultFace: '',
            versionContentVisible: false,
            versionInfo: {
                num: '',
                content: ''
            },
            shareSettingDialog: false,
            pageDataList: [],
            totalServer: 0,
            channelList: [],
            channelNameMap: {},
            minVersionList: [],
            suspendInfoList: []
        }
    },
    directives: {
        loadMore: {
            inserted(el, binding) {
                const selectWrap = el.querySelector('.el-table__body-wrapper');

                el.handle = (ev) => {
                    let { offsetHeight, scrollHeight, scrollTop } = ev.srcElement;
                    if (offsetHeight + scrollTop === scrollHeight && vm.versionList.length < vm.total) {
                        binding.value();
                    }
                };

                selectWrap.addEventListener('scroll', el.handle, true);
            },
            unbind(el) {
                const selectWrap = el.querySelector('.el-table__body-wrapper');
                selectWrap.removeEventListener('scroll', el.handle, true);
            }
        }
    },
    methods: {
        copy(text) {
            let copyInput = this.$refs.text;
            copyInput.value = text;
            copyInput.select();
            document.execCommand('copy');
            this.$message.success('复制成功！');
        },
        changeImg() {
            this.$refs.avatar.$el.children[1].click();
        },
        changeLogo(url) {
            dao.shop.changeLogo({
                appId: this.appInfo.appId,
                logo: url
            }).then(_ => {
                this.appInfo.logo = url;
            }).catch(msg => {
                this.$message.error(msg);
            });
        },
        clear(event) {
            this.nameBackup = '';
            this.$refs.input.focus();
            event.preventDefault();
        },
        editName() {
            this.nameBackup = this.appInfo.name;
            this.editType = true;
            this.$nextTick(_ => {
                this.$refs.input.focus();
            });
        },
        changeName() {
            if (this.nameBackup === this.appInfo.name) {
                this.editType = false;
                return;
            }
            if (!this.nameBackup) {
                this.errorInfo = '输入内容不能为空';
            } else if (!new RegExp(this.nameReg).test(this.nameBackup)) {
                this.errorInfo = '只能输入中文、英文和数字, 限4-24个字';
            } else {
                dao.shop.changeName({
                    appId: this.appInfo.appId,
                    name: this.nameBackup
                }).then(_ => {
                    this.appInfo.name = this.nameBackup;
                    this.editType = false;
                    this.errorInfo = '';
                }).catch(msg => {
                    this.editType = false;
                    this.nameBackup = this.appInfo.name;
                    this.$message.error(msg);
                });
            }
        },
        editIntro() {
            this.introBackup = this.appInfo.introduction;
            this.editIntroType = true;
            this.showIntroInput = true;
            this.$nextTick(_ => {
                this.$refs.intro.focus();
            });
        },
        changeIntro() {
            if (this.introBackup === this.appInfo.introduction) {
                this.editIntroType = false;
                this.showIntroInput = false;
                return;
            }
            dao.shop.changeIntro({
                appId: this.appInfo.appId,
                introduction: this.introBackup
            }).then(_ => {
                this.appInfo.introduction = this.introBackup;
                this.showIntroInput = false;
                this.editIntroType = false;
                this.errorInfo = '';
            }).catch(msg => {
                this.showIntroInput = false;
                this.editIntroType = false;
                this.introBackup = this.appInfo.introduction;
                this.$message.error(msg);
            });
        },
        timeFormat(str) {
            let date = new Date(str);
            return date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日';
        },
        showServerDomain() {
            if (this.serverLimit === 0) {
                return;
            }
            this.serverInfo = Object.assign({}, this.domainInfo);
            this.serverDomainDialogVisible = true;
        },
        showBusinessDomain() {
            if (this.busiLimit === 0) {
                return;
            }
            this.businessInfo = Object.assign({}, this.domainInfo);
            this.businessDomainDialogVisible = true;
        },
        cancel() {
            this.serverDomainDialogVisible = false;
            this.businessDomainDialogVisible = false;
        },
        getCatsList() {
            dao.shop.getCats({
                appId: this.$route.params.appId
            }).then(data => {
                this.typeList = data && data.catTrees || [];
            }).catch(msg => {
                this.$message.error(msg);
            });
        },
        async getDomain() {
            await dao.shop.getDomainList({
                appId: this.$route.params.appId
            }).then(data => {
                this.domainInfo = data;
                // this.cancel();
            }).catch(msg => {
                this.$message.error(msg);
            })
        },
        processDomain(data) {
            Object.keys(data).forEach((key, item) => {
                if (data[key]) {
                    data[key].forEach(subItem => {
                        subItem.domain = subItem.domain.replace(/^\^/, '').replace(/com.*/, 'com').replace(/\.\*/, '*').replace(/[^\)]{1,1}\?/, $1 => `(${$1})`).replace(/\?/, '');
                        // subItem.domain = subItem.domain.replace(/^(https:\/\/|wss:\/\/)/, '');
                    });
                }
            });
            return data;
        },
        getLimitNo(type) {
            dao.shop.getModifyLimit({
                appId: this.$route.params.appId,
                limitType: type
            }).then(data => {
                type === 0 ? this.busiLimit = data : this.serverLimit = data;
            }).catch(msg => this.$message.error(msg))
        },
        getServerLimit(type) {
            dao.shop.getServerLimit({
                appId: this.$route.params.appId,
                limitType: 1
            }).then(data => {
                this.totalServer = data;
            }).catch(msg => this.$message.error(msg))
        },
        modifyRefresh(type) {
            this.getDomain();
            this.getLimitNo(type);
            this.getServerLimit(1);
        },
        showServiceDialog() {
            // this.serviceStatus = this.appInfo.status;
            this.suspendServiceDialogVisible = true;
        },
        closeServiceDialog() {
            this.suspendServiceDialogVisible = false;
        },
        showPreview() {
            this.previewVisible = true;
            this.suspendServiceDialogVisible = false
        },
        closePreview() {
            this.suspendServiceDialogVisible = true;
            this.previewVisible = false;
        },
        openConfirm(type, info) {
            this.ConfirmVisible = true;
            this.type = type;
            this.suspendServiceInfo = info;
        },
        suspendService() {
            let params = {
                appId: this.appInfo.appId,
                channelKeys: this.suspendServiceInfo && this.suspendServiceInfo.channel ? [this.suspendServiceInfo.channel.channelKey] : [(this.suspendInfoList[0] || {}).channelKey],
                channelUseStatus: 1,
                channelReasonEnum: this.suspendServiceInfo.reason,
                channelFixUptimestamp: this.suspendServiceInfo.realTime / 1000
            };
            if (this.suspendServiceInfo.reason === 2 || this.suspendServiceInfo.isRecoveryTime === 2) {
                delete params.channelFixUptimestamp
            }
            dao.shop.updateSuspendInfo(params).then(_ => {
                this.openConfirm('alreadySuspend');
                this.getInfo();
                this.success = true;
                this.serviceStatus = 1
                // this.appInfo.status = 1;
            }).catch(msg => {
                this.$message.error(msg);
            });
        },
        resumService() {
            let params = {
                appId: this.appInfo.appId,
                channelKeys: this.suspendServiceInfo && this.suspendServiceInfo.channel ? [this.suspendServiceInfo.channel.channelKey] : [(this.suspendInfoList[0] || {}).channelKey],
                channelUseStatus: 0
            };
            dao.shop.updateSuspendInfo(params).then(_ => {
                this.openConfirm('alreadyResum');
                this.success = true;
                this.serviceStatus = 0
                this.getInfo();
                // this.appInfo.status = 0;
            }).catch(msg => {
                this.$message.error(msg);
            });
        },
        closeConfirm() {
            this.ConfirmVisible = false;
            this.success = false;
            // this.serviceStatus = this.appInfo.status;
        },
        loadMore() {
            if(this.pageNum != 1) {
                this.getVersionList()
            }
        },
        async getVersionList() {
            await dao.shop.getBaseVersionList({
                appId: this.$route.params.appId,
                channelUuid: this.versionChannel,
                pageSize: 6,
                pageNum: this.pageNum
            }).then(data => {
                if (data && data.list) {
                    this.total = data.total;
                    this.pageNum++;
                    this.pageDataList = this.pageDataList.concat(data.list);
                    this.versionList = this.processVersionList(this.pageDataList);
                }
            }).catch(msg => this.$message.error(msg));
        },
        processVersionList(list) {
            let lastList = list && list.map(({ newContentList, ...item }) => ({
                ...item,
                newContentList: newContentList.map(({ text }) => text)
            }));
            return lastList;
        },
        setVersion() {
            // this.version = (this.minVersionList[0] || {}).minVersion || '';
            this.versionChannel = this.channelList[0].channelKey
            this.version = (this.minVersionList.find(item => item.channelKey === this.versionChannel) || {}).minVersion
            this.pageDataList = [];
            this.getVersionList();
            this.versionVisible = true;
        },
        handleCurrentChange(val) {
            if (val) {
                this.version = val.baseVersion;
            }
        },
        close() {
            this.versionVisible = false;
            this.pageNum = 1;
        },
        versionComfirm() {
            this.dialogInfo['versionSet'].title = `确认设置${this.version}为基础库最低版本吗？`
            this.openConfirm('versionSet');
        },
        submit() {
            dao.shop.updateMinVersionNew({
                appId: this.appInfo.appId,
                channelKeys: [this.versionChannel],
                minBaseVersionNumber: this.version
            }).then(() => {
                this.appInfo.minVersion = this.version;
                this.versionVisible = false;
                this.$message.success('最低版本设置成功');
                this.getInfo();
                this.closeConfirm();
                this.close();
            }).catch(msg => this.$message.error(msg));
        },
        showExample() {
            this.exampleVisible = true;
        },
        showAll(row) {
            this.versionContentVisible = true;
            this.versionInfo.num = row.baseVersion;
            // this.versionInfo.content = row.content.replace(/↵/g,"<br/>");;
            this.versionInfo.content = row.newContentList;
        },
        openDetail() {
            // window.open('http://miniapp.bilibili.com/small-app-doc/lib/set-lowest-version/');
            let url;
            if (this.isSmallGame) {
                url = 'http://miniapp.bilibili.com/small-game-doc/open/sdk-update';
            }
            else {
                url = 'http://miniapp.bilibili.com/small-app-doc/lib/update-logs';
            }
            window.open(url);
        },
        setShareSetting() {
            this.shareSettingDialog = true;
        },
        closeShareSeeting() {
            this.shareSettingDialog = false;
        },
        getInfo() {
            // 获取渠道信息
            dao.shop.getChannel({
                miniappId: this.$route.params.appId,
                miniappType: 1
            }).then(data => {
                this.channelList = data.channelEnumModels;
                this.channelList.map(item => {
                    this.channelNameMap[item.channelKey] = item.channelName;
                });
                // 获取最低基础库版本信息
                dao.shop.getAppMinVersionList({
                    appId: this.$route.params.appId,
                    channelKeys: this.channelList.map(item => item.channelKey)
                }).then(data => {
                    this.minVersionList = (data || []).filter(item => item.minBaseVersionNumber).map(item => {
                        return {
                            channelKey: item.channelKey,
                            channelName: this.channelNameMap[item.channelKey],
                            minVersion: item.minBaseVersionNumber
                        }
                    })
                    this.suspendInfoList = (data || []).map(item => {
                        return {
                            channelKey: item.channelKey,
                            channelName: this.channelNameMap[item.channelKey],
                            status: item.miniAppStatus // 0：使用中 1:暂停中
                        }
                    })
                    if(this.suspendInfoList.length === 1) {
                        this.serviceStatus = this.suspendInfoList[0].status
                    }
                }).catch(msg => this.$message.error(msg));
            }).catch(msg => this.$message.error(msg));
        },
        versionChannelChange(value) {
            this.pageNum = 1
            this.pageDataList = []
            this.version = ((this.minVersionList || []).find(item => item.channelKey === value) || {}).minVersion
            this.getVersionList();
        }
    },
    mounted() {
        vm = this;
        this.getCatsList();
        this.getLimitNo(0);
        this.getLimitNo(1);
        this.getServerLimit(1);
        this.getDomain();
        this.getInfo();
        // this.getVersionList();
    }
}
</script>
<style lang="less" scoped>
.content-all {
    padding: 20px;
    border: 1px solid #e0e5ec;
    background: #fff;
    color: #6d757a;
    position: relative;
    font-size: 14px;
    .domain-type {
        height: 20px;
        font-weight: 500;
        margin-bottom: 10px;

        .domain-name {
            min-width: 170px;
            font-size: 16px;
        }
        .edit-btn {
            margin-top: 23px;
            text-align: center;
            font-size: 14px;
            color: #789aff;
            line-height: 20px;
            position: relative;
            left: 85%;
            height: line-height;
            cursor: pointer;

            &.ep {
                left: 87%;
            }
            .edit-icon {
                width: 16px;
                height: 16px;
                display: inline-block;
                background: url(./../../assets/icon_edit.png) center center
                    no-repeat;
                background-size: 100% 100%;
                vertical-align: bottom;

                &.edit-icon-disabled {
                    width: 14px;
                    height: 14px;
                    display: inline-block;
                    background: url(./../../assets/edit-gray@2x.png) center
                        center no-repeat;
                    background-size: 100% 100%;
                    vertical-align: bottom;
                }
            }
            .text {
                vertical-align: bottom;

                &.text-disabled {
                    color: #9aa7c1;
                }
                &.text-disabled:hover {
                    text-decoration: none;
                }
            }
            .text:hover {
                text-decoration: underline;
            }
            &.edit-disabled {
                cursor: not-allowed;
            }
        }
    }
    .head {
        line-height: 40px;
        height: 40px;
        background: #f2f3f6;
        font-size: 14px;
        padding: 0 20px;
        margin-bottom: 15px;
        position: relative;
        .sub {
            position: absolute;
            right: 20px;
            &.sub-disable {
                left: 471px;
            }
        }
        .description {
            position: absolute;
            left: 486px;
        }
        .operator {
            position: absolute;
            left: 740px;
        }
    }
    .disable-tips {
        position: absolute;
        left: 760px;
        top: 126px;
        width: 220px;
    }

    .form {
        font-size: 14px;
        .disable-tips {
            width: 330px;
            position: absolute;
            left: 491px;
            top: 95px;
        }
        .row {
            line-height: 60px;
            min-height: 60px;
            padding: 0 20px;
            border-bottom: 1px solid #e0e5ec;

            &:last-child {
                border-bottom: none;
            }

            border-bottom: 1px solid #e0e5ec;
            &.row-lines2 {
                line-height: 80px;
                min-height: 80px;
                position: relative;
                .title {
                    line-height: 20px;
                    padding: 20px 0;
                }
                .desc,
                .btn {
                    position: absolute;
                    right: 115px;
                    top: 20px;
                    width: 360px;
                    line-height: 20px;
                }
                .btn {
                    right: 20px;
                    width: auto;
                    text-align: right;
                    line-height: 40px;
                }
                .detail-btn {
                    cursor: pointer;
                    color: #789aff;
                }
            }
            &.dev {
                line-height: 60px;
                border-bottom: 1px solid #e0e5ec;
            }
            &.last {
                line-height: 60px;
            }
            &.domain {
                display: flex;

                .left {
                    line-height: 25px;
                    width: 261px;
                    text-align: left;
                    margin-right: 205px;
                    p {
                        color: #222;
                    }
                }
                .right {
                    line-height: 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }
            .title {
                width: 73px;
                margin-right: 30px;
                display: inline-block;
                vertical-align: top;
                text-align: left;

                &.long {
                    display: inline-block;
                    width: 158px;
                    margin-right: 20px;
                }
            }
            .content {
                display: inline-block;
                position: relative;
                max-width: 820px;
                color: #5c667e;
                img[src=""],
                img:not([src]) {
                    opacity: 0;
                    margin-top: 20px;
                }
                .service-description {
                    width: 30%;
                }
                .info {
                    cursor: pointer;
                    height: 22px;
                    display: inline-block;
                    min-width: 153px;
                    line-height: 18px;
                    margin-top: 12px;
                    word-break: break-all;
                    color: #222;

                    .piece {
                        display: inline-block;
                        margin-top: 6px;
                    }
                    .piece::after {
                        content: '、';
                    }
                    .piece:last-child::after {
                        content: '';
                    }

                    &.type {
                        width: 366px;
                        .type-item {
                            height: 20px;
                            color: #222;
                            padding: 7px 10px;
                            background: #eff4fc;
                            border-radius: 4px;
                            margin-right: 10px;
                            line-height: 20px;
                            display: inline-block;
                            white-space: nowrap;
                            margin-bottom: 10px;
                        }
                    }

                    &.textarea-info {
                        width: 366px;
                    }

                    &.service-status {
                        width: 366px;
                    }
                }
                .edit-content {
                    position: relative;
                    height: 28px;
                    display: inline-block;
                    line-height: 28px;
                }
                .edit-textarea {
                    position: relative;
                    height: 70px;
                }
                .input {
                    border: 1px solid #e0e5ec;
                    height: 28px;
                    border-radius: 17px;
                    box-sizing: border-box;
                    padding: 0 30px 0 10px;
                    color: #5c667e;
                    font-size: 14px;
                    width: 230px;
                    outline: none;

                    &.bigInput {
                        padding: 5px;
                        width: 320px;
                        height: 105px;
                        margin-top: 13px;
                        border-radius: 2px;
                    }
                }
                .input:focus ~ .action {
                    display: block;
                }
                .action {
                    position: absolute;
                    height: 100%;
                    top: 0;
                    right: 10px;
                    text-align: center;
                    height: 28px;
                    display: none;

                    .act-icon {
                        cursor: pointer;
                    }
                }
                .clear {
                    width: 17px;
                    display: inline-block;
                    background: url(../../assets/close.png) center / 17px
                        no-repeat;
                    height: 100%;
                }
                .error-info {
                    color: #ff7b58;
                    font-size: 12px;
                    line-height: 14px;
                    position: absolute;
                    bottom: 0;
                    left: 11px;
                }
                .input::-moz-placeholder {
                    color: #9aa7c1;
                    font-size: 12px;
                }
                .input::-webkit-input-placeholder {
                    color: #9aa7c1;
                    font-size: 12px;
                }
                .input::-ms-input-placeholder {
                    color: #9aa7c1;
                    font-size: 12px;
                }
            }
            .base-content {
                max-width: 350px;
            }
            .btn {
                cursor: pointer;
                color: #789aff;
                float: right;
                top: 20px;
            }
            &.row-lines3 {
                color: #5c667e;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                position: relative;

                .title {
                    line-height: 20px;
                }
                .content img {
                    border-radius: 7px;
                    margin-top: 20px;
                }
                .no-share-image {
                    color: #222222;
                    width: 802px;
                }
                .desc,
                .btn {
                    position: absolute;
                    right: 115px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 360px;
                    line-height: 20px;
                    &.share-info {
                        word-wrap: break-word;
                    }
                }
                .btn {
                    right: 20px;
                    width: auto;
                    text-align: right;
                }
            }
        }
    }
    .textarea {
        position: absolute;
        top: 10px;
        left: 5px;
        z-index: -1;
    }
    .input-file {
        position: absolute;
        top: 10px;
        left: 5px;
        z-index: -1;
    }
    .btn-text {
        color: #789aff;
        line-height: 17px;
        cursor: pointer;
    }
    .version-dialog {
        .title-dialog {
            color: #5c667e;
            font-size: 18px;
        }
        .content {
            color: #5c667e;
            font-size: 12px;
            padding: 0 32px;
            margin-top: -17px;
            line-height: 17px;
            .table-version {
                margin-top: 17px;
                margin-bottom: 29px;
                .table-row {
                    cursor: pointer;
                    &.current-row {
                        .table-cell {
                            background-color: #fff;
                        }
                    }
                }
                .table-cell,
                .table-header-cell {
                    font-size: 12px;
                    line-height: 12px;
                    .cell {
                        line-height: 12px;
                        .circle {
                            width: 20px;
                            height: 20px;
                            border-radius: 10px;
                            border: 1px solid #cad3e1;
                            margin: 0 auto;
                            &.active {
                                background-color: #789aff;
                                border-color: #789aff;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                &:after {
                                    content: " ";
                                    display: block;
                                    width: 8px;
                                    height: 8px;
                                    border-radius: 4px;
                                    background-color: #fff;
                                }
                            }
                        }
                        .v-content {
                            text-align: left;
                            .btn-text {
                                font-size: 12px;
                            }
                        }
                    }
                }
                .table-header-cell {
                    background: #f2f3f6;
                    color: #6d757a;
                    padding: 8px 0;
                }
                .table-cell {
                    padding: 10px 0;
                }
            }
        }
        .footer {
            text-align: center;
        }
    }
    .example-dialog {
        background: #f2f3f6;
        .title-dialog {
            color: #5c667e;
            font-size: 18px;
        }
        .version-container {
            line-height: 20px;
            margin-top: -40px;
            word-break: break-all;
            max-height: 700px;
            overflow-y: auto;
        }
        .example-img {
            width: 240px;
            height: 427px;
            background-color: black;
            margin: -9px auto 0;
            background: ~"url(../../assets/example.png) no-repeat 0 0 / 240px 427px";
            position: relative;
            .appInfo {
                position: absolute;
                left: 0;
                right: 0;
                text-align: center;
                font-weight: bold;
                font-size: 12px;
                top: 135px;
                img {
                    margin-bottom: 10px;
                    border-radius: 24px;
                }
            }
        }
    }
}
.confirm-dialog {
    .icon-success {
        width: 30px;
        height: 30px;
        display: inline-block;
        background: url(./../../assets/icon-done@2x.png) center center no-repeat;
        background-size: 100% 100%;
        vertical-align: bottom;
        margin-bottom: 17px;
        margin-left: 46%;
    }
    .tips {
        text-align: center;
    }
    .op-btns {
        text-align: center;
        .add {
            margin-right: 10px;

            &:last-child {
                margin-right: 0;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/manage/Setting.vue